<template>
  <tr :class="$style.container" @click="onRowClick">
    <td :class="$style.statusWrapper">
      <div :class="$style.status" :style="{background: status.color}">
        {{ status.name }}
      </div>
    </td>

    <td>
      <div :class="$style.id" :style="{background: status.color}">№ {{ item.id }}</div>
      <div :class="$style.date">от {{ createdAt }}</div>
    </td>

    <td>
      <div :class="$style.info">
        <div>
          <div :class="$style.address">{{ address }}</div>
          <div :class="$style.owner">{{ item.owner ? item.owner.name: '-' }}</div>
        </div>
        <app-tag
          color="success" :class="$style.unreaded"
          v-if="unreadCount"
          v-text="unreadCount" :title="unreadCount"
          :key="`unreadCount-${item.id}-${unreadCount}`"
        />
      </div>
    </td>

    <td>
      <div :class="$style.message">
        {{ item.description }}
      </div>
    </td>

    <td>
      <div :class="$style.performer">
        <template v-if="item.performer">
          <app-avatar
            :img="item.performer.avatar | imgPath"
            :name="item.performer.name"
            :class="$style.performerAvatar"
            size="28px"
          />
          <div :class="$style.performerName">{{ item.performer.name }}</div>
        </template>
        <template v-else>
          Не назначено
        </template>
      </div>
    </td>

    <td>
      <div :class="$style.category">
        <app-icon :class="$style.categoryIcon" :name="category.icon" size="24px" :style="{color: category.color}" />
        {{ category.nameShort }}
      </div>
    </td>
  </tr>
</template>

<script>
import formatDate          from 'date-fns/format';
import generateFullAddress from "@/functions/generateFullAddress";

export default {
  name:     "IssuesRow",
  props:    ['item'],
  computed: {
    status() {
      return this.$store.getters['common/tasks/statusById'](this.item.status_id);
    },
    category() {
      return this.$store.getters['common/tasks/categoryById'](this.item.category_id);
    },
    unreadCount() {
      let unread = this.$store.getters['common/tasks/unreadMessagesById'](this.item.id);
      let unreadText = null;
      if (unread) {
        unreadText = unread > 99 ? '99+' : unread;
      }
      return unreadText;
    },
    createdAt() {
      const date = new Date(this.item.created_at.replace(' ', 'T'));
      return formatDate(date, 'dd.MM.yyyy HH:mm:ss');
    },
    address() {
      const { item } = this;
      return generateFullAddress(item.apart, item.building);
    },
  },
  methods:  {
    onRowClick() {
      this.$router.push({ name: 'uc_issue', params: { id: this.item.id } });
    },
  },
};
</script>

<style lang="scss" module>
.container {
  cursor: pointer;
  font-size: 13px;
  @include anim();

  &:nth-child(2n) {
    background: #F5F8FA;
  }

  td {
    padding: 11px 13px;
    border-bottom: 1px solid #CCCCCC;
    vertical-align: top;

    &:first-child {
      padding-left: 0;
    }

    &:last-child {
      padding-right: 20px;
    }
  }

  &:hover {
    background: rgba(0, 174, 239, .1);
  }
}

.statusWrapper {
  position: relative;
  min-width: 120px;
  width: 160px;
}

.status {
  height: 40px;
  border-radius: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  font-weight: 600;
}

.id {
  display: inline-block;
  border-radius: 3px;
  color: #ffffff;
  font-weight: 600;
  font-size: .95em;
  padding: 3px 6px;
}

.date {
  margin-top: .1em;
  white-space: nowrap;
  font-weight: 500;
}

.info {
  display: flex;
  align-items: flex-start;
}

.unreaded {
  margin-left: 1em;
}

.address {
  font-size: 1.1em;
  font-weight: 500;
}

.message {
  max-width: 370px;
  line-height: 1.25;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  max-height: calc(1em * 1.25 * 2);
}

.performer {
  display: flex;
  align-items: center;
}

.performerAvatar {
  display: inline-block;
  margin-right: .5em;
}

.performerName {
  font-size: 1.1em;
  font-weight: 500;
}

.category {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  font-weight: 500;
  //padding-right: 4px;
}

.categoryIcon {
  margin-right: 1em;
}
</style>
